module.exports = __webpack_public_path__ + "img/MaskGroup1.27276a86.svg";